import { auth } from '@onevision-resources/login';
import { portalPaths } from '@provision/portal-routes';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import {
  AllowedRuleSet,
  MatchType,
  PartnerGroupRules,
  useGroupRules,
  UserGroupRules,
} from 'src/graphql';

export const ProtectedPage = ({
  allowedRules,
  disallowedRules,
  redirectTo,
  matchType = 'any',
}: {
  allowedRules?: (UserGroupRules | PartnerGroupRules | AllowedRuleSet)[];
  disallowedRules?: (UserGroupRules | PartnerGroupRules)[];
  redirectTo?: string | null;
  matchType?: MatchType;
}) => {
  const { checkValidity, loading } = useGroupRules();
  const context = useOutletContext();

  if (loading) return null;

  const isAllowed = !allowedRules || checkValidity(allowedRules, { matchType });
  const isDisallowed = disallowedRules && checkValidity(disallowedRules, { matchType });

  if (!auth.authorized || !isAllowed || isDisallowed) {
    return <Navigate to={redirectTo || portalPaths.root()} />;
  }

  return <Outlet context={context} />;
};
